<template>
  <v-list class="person-list">
    <template>
      <v-list-tile v-for="item in items" :key="item.person">
        <v-list-tile-avatar size="40px">
          <v-icon class="secondary">person</v-icon>
        </v-list-tile-avatar>

        <v-list-tile-content>
          <v-list-tile-title v-html="item.person"></v-list-tile-title>
          <v-list-tile-sub-title class="role">
            {{ roleName(item.role) }}
          </v-list-tile-sub-title>
        </v-list-tile-content>

        <v-list-tile-action>
          <!-- <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }"> -->
              <v-btn icon @click="remove(item)" class="remove">
                <v-icon>clear</v-icon>
              </v-btn>
            <!-- </template>
            <span>Usuń osobę z listy, jeśli raczej nie będzie się już pojawiać na następnych spotkaniach</span>
          </v-tooltip> -->

          <!-- <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }"> -->
              <v-checkbox
                :inputValue="item.present"
                color="accent"
                @change="(v) => toggle(item.person, v)"
              ></v-checkbox>
            <!-- </template>
            <span>Zaznacz obecność osoby</span>
          </v-tooltip> -->
        </v-list-tile-action>
      </v-list-tile>
    </template>
    <div v-if="!items.length" class="accent--text">Lista jest pusta</div>
  </v-list>
</template>

<script>
// import { mapAll } from '@/store'
import { mapGetters } from 'vuex'

export default {
  computed: {
    items() {
      return this.$store.getters['meeting2/attendance']
    },
    ...mapGetters(['roleName']),
  },

  methods: {
    remove(item) {
      this.$store.dispatch('meeting2/removePerson', item)
    },
    toggle(person, value) {
      this.$store.commit('meeting2/attendance', { person, value })
    },
  },
}
</script>

<style lang="stylus">
.person-list {
  .v-list__tile {
    padding: 0 !important;
  }
}

.v-input {
  justify-content: flex-end;
}

.v-input--checkbox {
  margin-bottom: 11px !important;
}

.v-list__tile__action.v-list__tile__action--stack {
  flex-direction: row;
}

.role {
  color: silver;
}

.remove {
  margin: 0 8px 5px 0 !important;

  i {
    color: rgba(0, 0, 0, 0.54) !important;
  }
}
</style>
